/* 教学成效 */
export default [{
  // 教学成效
  path: '/jxeffectTwo',
  name: 'JxeffectTwo',
  redirect: '/jxeffectTwo/index',
  component: () => import('@/views/jxeffectTwo/layout'),
  children: [{
      path: '/jxeffectTwo/index',
      name: 'JxeffectTwoHome',
      component: () => import('@/views/jxeffectTwo/index'),
    },
    {
      path: '/jxeffectTwo/teachDetail',
      name: 'JxeffectTwoTeachDetail',
      component: () => import('@/views/jxeffectTwo/teachDetail'),
    },
    {
      path: '/jxeffectTwo/courseInfo',
      name: 'JxeffectTwoCourseInfo',
      component: () => import('@/views/jxeffectTwo/courseInfo'),
    },
    {
      path: '/jxeffectTwo/moreEvaluation',
      name: 'JxeffectTwomoreEvaluation',
      component: () => import('@/views/jxeffectTwo/moreEvaluation'),
    },
    {
      path: '/jxeffectTwo/moreStuLearning',
      name: 'JxeffectTwomoreStuLearning',
      component: () => import('@/views/jxeffectTwo/moreStuLearning'),
    },
    {
      path: '/jxeffectTwo/studentPortrayal',
      name: 'JxeffectTwoStudentPortrayal',
      component: () => import('@/views/jxeffectTwo/studentPortrayal'),
    },
    // 学生个人画像假数据
    {
      path: '/jxeffectTwo/editStudentPortrayal',
      name: 'JxeffectTwoEditStudentPortrayal',
      component: () => import('@/views/jxeffectTwo/editStudentPortrayal'),
    },
    {
      // 学生预习情况更多
      path: '/jxeffectTwo/prepare',
      name: 'jxeffectTwoPrepare',
      component: ()=> import('@/views/jxeffectTwo/more/prepareMore')
    },{
      // 学生测验情况更多
      path: '/jxeffectTwo/test',
      name: 'jxeffectTwoTest',
      component: ()=> import('@/views/jxeffectTwo/more/testMore')
    },{
      // 学生作业情况更多
      path: '/jxeffectTwo/job',
      name: 'jxeffectTwoJob',
      component: ()=> import('@/views/jxeffectTwo/more/jobMore')
    }
  ]
}]
